import { jsx as _jsx } from "react/jsx-runtime";
import { useBrand } from "@aviv-unified-frontend/runtime/brand";
import { BRAND_CONFIGURATION } from "../../../configs/brands";
import { useConsentServiceStatus } from "../../utils/consentManagement";
import { useShouldInitOverlay } from "../OverlayOrchestrator";
import { AirshipLoader as Airship } from "./AirshipLoader";
export const AirshipLoader = () => {
    const config = BRAND_CONFIGURATION.airship;
    const { id } = useBrand();
    const { appKey, token, vapidPublicKey, trackingConsentId, pushConsentId } = config ?? {};
    const hasTrackingConsent = useConsentServiceStatus(trackingConsentId);
    const hasPushConsent = useConsentServiceStatus(pushConsentId);
    const shouldInit = useShouldInitOverlay("airship");
    if (!appKey || !token || !vapidPublicKey || !shouldInit) {
        return null;
    }
    return (_jsx(Airship, { appKey: appKey, brand: id, hasPushConsent: hasPushConsent, hasTrackingConsent: hasTrackingConsent, token: token, vapidPublicKey: vapidPublicKey, businessType: BRAND_CONFIGURATION.type.toUpperCase() }));
};
